module.exports = "<h3>{{title}}</h3>\r\n<p>{{message}}</p>\r\n<div style='float: right;'>\r\n\t<button class=\"btn-cancel\" mat-button (click)=\"dialogRef.close()\">{{buttonCancel}}</button>\r\n\t<button class=\"btn-confirm\" mat-button (click)=\"dialogRef.close(true)\" color=\"primary\">{{buttonOk}}</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirm-dialog/confirm-dialog.component.html
// module id = ./src/app/shared/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main